/* eslint no-alert: 0 */

import Components from "../components";

class ShortcutForm extends Components.Base {
  unbind() {
    this.button.off("click");
  }

  initialize() {
    this.apiKey = this.$el.find("#channel_api_key");
    this.customFieldsInput = this.$el.find("#channel_custom_fields");
    this.teamSelect = this.$el.find("#channel_team");
    this.initialSelect = this.$el.find("#channel_initial_state");
    this.resolveSelect = this.$el.find("#channel_resolve_transition");
    this.reopenSelect = this.$el.find("#channel_reopen_transition");
    this.projectId = this.$el.data("channel-shortcut-v2-project-id-value");
    this.channelId = this.$el.data("channel-shortcut-v2-channel-id-value");

    this.customFieldsContainer = $("<div>", { id: "custom_fields_container" });
    this.customFieldsInput.after(this.customFieldsContainer);
    this.customFieldsInput.attr("readonly", true);
    this.customFieldsInput.attr("type", "hidden");
    this.$el.find("select").attr("disabled", true);

    this.$el.find("#fetch_custom_fields_and_workflow_data").remove();
    this.button = $("<button>", {
      text: "Fetch custom fields and workflow data",
      class: "btn btn-sm btn-soft-primary mt-2",
      id: "fetch_custom_fields_and_workflow_data",
      type: "button",
    });
    this.button.on("click", (e) => {
      e.preventDefault();
      this.fetchCustomFieldsInfo()
        .then(this.fetchGroupInfo)
        .then(this.fetchWorkflowInfo);
    });
    this.$el.find(".mb-3:has(#channel_api_key)").append(this.button);

    if (this.apiKey.val().length > 0) {
      this.fetchCustomFieldsInfo()
        .then(this.fetchGroupInfo)
        .then(this.fetchWorkflowInfo);
    }
  }

  buildUrl(path) {
    const params = new URLSearchParams({ token: this.apiKey.val() });
    if (this.channelId) {
      params.set("channel_id", this.channelId);
    }
    return `/projects/${this.projectId}/channels/shortcut${path}?${params}`;
  }

  fetchCustomFieldsInfo() {
    return $.ajax(this.buildUrl("/custom_fields"), {
      context: this,
      type: "get",
      dataType: "json",
      success: (...args) => this.populateCustomFields(...args),
      error: (...args) => this.reportError(...args),
    });
  }

  fetchGroupInfo() {
    return $.ajax(this.buildUrl("/groups"), {
      context: this,
      type: "get",
      dataType: "json",
      success: (...args) => this.populateGroups(...args),
      error: (...args) => this.reportError(...args),
    });
  }

  fetchWorkflowInfo() {
    return $.ajax(this.buildUrl("/workflows"), {
      context: this,
      type: "get",
      dataType: "json",
      success: (...args) => this.populateWorkflowStates(...args),
      error: (...args) => this.reportError(...args),
    });
  }

  populateCustomFields(customFields) {
    this.customFieldsContainer.html("");
    customFields
      .filter((cf) => cf.enabled)
      .forEach((customField) => {
        const select = $("<select>", { class: "field-select form-select" })
          .on("change", () => {
            this.customFieldsInput.val(
              [...$(".field-select").map((i, s) => s.value)]
                .filter((n) => n)
                .join(","),
            );
          })
          .append($("<option>"));

        customField.values
          .filter((v) => v.enabled)
          .forEach((value) => {
            const optionValue = `${customField.id}:${value.id}`;
            select.append(
              $("<option>", {
                value: optionValue,
                text: value.value,
                selected: this.customFieldsInput.val().includes(optionValue),
              }),
            );
          });

        this.customFieldsContainer.append(
          $("<div>", { class: "form-group row" })
            .append(
              $("<label>", {
                text: customField.name,
                class: "col-sm-2 col-form-label text-end",
              }),
            )
            .append($("<div>", { class: "col-sm-10" }).append(select)),
        );
      });
  }

  populateGroups(groups) {
    [this.teamSelect].forEach((sel) => {
      const selected = sel.attr("value");
      sel.empty();
      groups.forEach((group) => {
        sel.append(
          $("<option>", {
            value: group.id,
            text: group.name,
            selected: group.id === selected,
          }),
        );
      });
      sel.removeAttr("disabled");
    });
  }

  populateWorkflowStates(workflows) {
    [this.initialSelect, this.resolveSelect, this.reopenSelect].forEach(
      (sel) => {
        const selected = Number.parseInt(sel.attr("value"), 10);
        sel.empty();
        workflows.forEach((workflow) => {
          workflow.states.forEach((state) => {
            sel.append(
              $("<option>", {
                value: state.id,
                text: `${workflow.name} - ${state.name}`,
                selected: state.id === selected,
              }),
            );
          });
        });
        sel.removeAttr("disabled");
      },
    );
  }

  reportError(xhr, status, error) {
    if (error.match(/forbidden/i)) {
      alert("Shortcut access denied: Invalid API Key");
    }
  }
}

Components.collection.register({
  selector: "form[data-kind=shortcut_v2]",
  klass: ShortcutForm,
});
